import { Select } from '@podiumhq/design-system';

export const FormElementSelect = ({
  selectList = [],
  sx,
  variant,
  ...props
}) => {
  // this 'hack' is due to design actually wanting the basic variant for select
  // to look different from the inputs but our design wants it to look the same.
  const isBasic = variant === 'basic';
  const selectSx = isBasic ? { backgroundColor: 'silver.lighter', ...sx } : sx;

  return (
    <Select sx={selectSx} variant={isBasic ? 'outline' : variant} {...props}>
      {selectList.map((item) => {
        const value = item?.id || item;
        return (
          <option key={value} value={value}>
            {item?.displayValue || item}
          </option>
        );
      })}
    </Select>
  );
};
